// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const Modules = {
  Dashboard: 1,
  UserManagement: 2,
  RoleManagement: 3,
  WillManagement: 4,
  SystemConfiguration: 5,
  CustomerManagement: 7,
  WillManagement_Insurance: 8,
  WillManagement_Loans: 9,
  WillManagement_Investments: 10,
  WillManagement_Recurring: 11,
  WillManagement_Policy: 12,
  Subscriptions: 13,
  CouponManagement: 14,
  Blogs: 15,
  Inquiry: 16,
  Calculators: 17,
  Accounts: 18,
  Marketing: 19,
  Support : 20,
  Template:21,
  Campaign:22,
  Subscriber:23
};    


export const SystemConfiguration = {
  SendGrid: 1,
  TwilioAccountSid: 2,
  TwilioSMSAuthToken: 3,
  SenderEmail: 4,
  TwilioMobileNumber: 5
};

export const MODULE_KEYS = {
  Dashboard: "dashboard",
  Blogs: "blogs",
  Inquiry: "inquiry",
  Plan_Management: "plan_management",
  Accounts: "accounts",
  Marketing: "marketing",
  Support: "support",
  User_Management: "user_management",
  Role_Management: "role_management",
  Subscriber: "subscriber",
  Template: "template",
  Campaign: "campaign"
};


